import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.JSX.Element}
 */
const IconAmenitiesAccessibleComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Head */}
        <circle cx="13" cy="4" fill="currentColor" r="2" stroke="none" />
        {/* Torso, seat and shin */}
        <path d="M12 7.5V13h4.5l1.5 4.5" />
        {/* Arm */}
        <path d="M12 9.5h3.5" />
        {/* Rear wheel */}
        <circle cx="9.5" cy="17" r="4.5" />
        {/* Front caster */}
        <circle cx="17.5" cy="20" r="1.5" />
      </svg>
    </SvgIcon>
  );
};

IconAmenitiesAccessibleComponent.displayName = 'IconAmenitiesAccessible';

const IconAmenitiesAccessible = React.memo(IconAmenitiesAccessibleComponent);

export default IconAmenitiesAccessible;
